interface PackageComponent {
	icon: string;
	contentKey: string;
	contentKeyShort?: string;  // Optional shorter version for NL/UK
}

interface PackageComposition {
	components: PackageComponent[];
}

const packageCompositionConfig: Record<string, PackageComposition> = {
	HS: {
		components: [
			{ icon: 'home', contentKey: 'packages_home' }
		]
	},
	PF: {
		components: [
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' }
		]
	},
	PFCS: {
		components: [
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' }
		]
	},
	PFP: {
		components: [
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
			{ icon: 'materiel', contentKey: 'packages_material' }
		]
	},
	PFPF: {
		components: [
			{ icon: 'flight', contentKey: 'packages_flight', contentKeyShort: 'packages_flight' },
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
			{ icon: 'materiel', contentKey: 'packages_material_short' }
		]
	},
	PFF: {
		components: [
			{ icon: 'flight', contentKey: 'packages_flight', contentKeyShort: 'packages_flight' },
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
		]
	},
	PFPCS: {
		components: [
			{ icon: 'home', contentKey: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
			{ icon: 'materiel', contentKey: 'packages_material' }
		]
	},
	PFTT: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' }
		]
	},
	PFTTF: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' }
		]
	},
	PFPTTF: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
			{ icon: 'materiel', contentKey: 'packages_material' }
		]
	},
	PMA: {
		components: [
			{ icon: 'home', contentKey: 'packages_home' },
			{ icon: 'skipass', contentKey: 'planningSummary_options_passMultiActivities' }
		]
	}
};

export default packageCompositionConfig;
export type { PackageComponent, PackageComposition }; 